import type { EventName } from "@lit/react";
import { LoginOverlay as LoginOverlayElement, type LoginOverlayEventMap as _LoginOverlayEventMap, } from "@vaadin/login/vaadin-login-overlay.js";
import * as React from "react";
import { createComponent, type WebComponentProps } from "../utils/createComponent.js";
export { LoginOverlayElement, };
export type LoginOverlayEventMap = Readonly<{
    onForgotPassword: EventName<_LoginOverlayEventMap["forgot-password"]>;
    onLogin: EventName<_LoginOverlayEventMap["login"]>;
    onDisabledChanged: EventName<_LoginOverlayEventMap["disabled-changed"]>;
    onErrorChanged: EventName<_LoginOverlayEventMap["error-changed"]>;
    onDescriptionChanged: EventName<_LoginOverlayEventMap["description-changed"]>;
}>;
const events = { onForgotPassword: "forgot-password", onLogin: "login", onDisabledChanged: "disabled-changed", onErrorChanged: "error-changed", onDescriptionChanged: "description-changed" } as LoginOverlayEventMap;
export type LoginOverlayProps = WebComponentProps<LoginOverlayElement, LoginOverlayEventMap>;
export const LoginOverlay = createComponent({
    elementClass: LoginOverlayElement, events, react: React, tagName: "vaadin-login-overlay"
});
